export const getewaysData = {
    parsian: {logo: "parsian.png", title: "بانک پارسیان"},
    saman: {logo: "saman.png", title: "بانک سامان"},
    sadad: {logo: "sadad.png", title: "بانک ملی"},
    sina: {logo: "saman.png", title: "بانک سینا"},
    pasargad: {logo: "pasargad.svg", title: "بانک پاسارگاد"},
    "saman-pars": {logo: "saman.png", title: "بانک سامان"},
    "sadad-pars": {logo: "sadad.png", title: "بانک ملی"},
    mellat: {logo: "mellat.png", title: "بانک ملت"},
    "mellat-pars": {logo: "mellat.png", title: "بانک ملت"},
};
